import { TypeDefinitionTypes } from '@eagle/common';
import { isObject, Operator } from '@jexop/core';
import { isString } from 'lodash';
import { Nullable } from '../types';
import { formatDate } from './format-date';
import { formatNumber } from './format-number';
import { formatTimestamp } from './format-timestamp';

export const formatProperty: Operator<string> = ({ value, definition }): Nullable<string> => {
  if (!isObject(definition)) {
    return null;
  }

  if (!value || !isString(value)) {
    return null;
  }

  switch (definition.type) {
    case TypeDefinitionTypes.TEXT:
    case TypeDefinitionTypes.BOOLEAN:
      return value;
    case TypeDefinitionTypes.NUMBER:
    case TypeDefinitionTypes.INTEGER:
      return formatNumber({ value, format: definition.format, type: definition.type });
    case TypeDefinitionTypes.DATE:
      return formatDate({ value, format: definition.format });
    case TypeDefinitionTypes.TIMESTAMP:
      return formatTimestamp({ value, format: definition.format });
    default:
      return value;
  }
};

